<div class="license-validation-wrapper ipm-container">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <ngx-spinner></ngx-spinner>
    <p>Verifying License...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="error-container">
    <div class="error-card">
      <i class="fas fa-exclamation-circle"></i>
      <h2>License Not Found</h2>
      <p>{{ errorMessage }}</p>
      <p class="error-description">The license you're trying to verify could not be found. Please check the QR code and try again.</p>
    </div>
  </div>

  <!-- Success State -->
  <div *ngIf="!isLoading && !errorMessage" class="verification-portal">

    <!-- Header -->
    <div class="portal-header">
      <!-- <h1 class="portal-title">LICENSE VERIFICATION PORTAL</h1> -->
    </div>

    <!-- Status Badge -->
    <div class="status-badge" [ngClass]="'badge-' + licenseStatus">
      <!-- <img src="assets/imgs/ShieldCheck.svg" alt="shield" width="20" height="20" /> -->
      <span>License Status: <i>{{ licenseStatus === 'expired' ? 'Expired' : 'Active' }}</i></span>
    </div>
    <div class="item-section w-100">
      <ipm-beats *ngIf="beatsList.length > 0" [beatsList]="beatsList" [forceViewType]="'list'" ></ipm-beats>
      <div class="sound-card-list" *ngIf="sound">
        <figure>
          <div class="sound-card-inner">
            <div class="sound-image-wrapper">
              <img
                class="sound-cover"
                [src]="sound.cover_image_url"
                [alt]="sound.title"
              />
            </div>
            <figcaption>
              <div class="sound-basic">
                <span class="sound-title" (click)="goToSoundDetails(sound.serial_number)">
                  {{ sound.title }}
                </span>
                <span class="sound-category">
                  {{ sound.category }}
                </span>
              </div>
            </figcaption>
          </div>
        </figure>
      </div>
    </div>
    <p class="portal-description">
      <i>Note:</i> This license has been digitally verified and recorded on the Beat22 platform.
      All details displayed below are authentic and correspond to a valid, immutable transaction.
    </p>
    <!-- License Info Grid (2×5) -->
    <div class="info-grid">
      <div class="info-item" *ngFor="let item of licenseInfoItems">
        <span class="info-label">{{ item.label }}</span>
        <span class="info-value">
          {{ item.value }}
          <button *ngIf="item.copyable" class="copy-btn" (click)="copyToClipboard(item.value)" title="Copy">
            <i class="fas fa-copy"></i>
          </button>
        </span>
      </div>
    </div>

    <!-- Middle Sections (3 columns) -->
    <div class="sections-grid">
      <div class="license-section" *ngFor="let section of licenseSections">
        <h3 class="section-title">{{ section.title }}</h3>
        <div class="section-rows">
          <div class="section-row" *ngFor="let row of section.rows" [ngClass]="'row-' + (row.status || 'default')">
            <span class="row-label">{{ row.label }}</span>
            <span *ngIf="row.value" class="row-value">{{ row.value }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
